<template>
  <div>
    <!-- 回款金额 -->
    <div class="trade-amount">
      <div class="ta-lf">
        <div>回款金额</div>
        <div class="font2 input">{{ $formatDecimals(returnedAmount,2) }}</div>
      </div>
      <div class="ta-rt1" v-if="selectedList">
        <div class="dc-rt">
          <img class="logo" :src="selectedList.imageUrl" alt="">
          <span>{{selectedList.symbol}}</span>
        </div>
      </div>
    </div>

    <!-- Alpha 积分信息 -->
<!--    <div class="alpha-info">-->
<!--      <div class="info-item" style="border-right: 0.5px solid #ECECEC;">-->
<!--        <div class="label">Alpha 有效交易金额</div>-->
<!--        <div class="value font2">$ {{alphaAmount}}</div>-->
<!--      </div>-->
<!--      <div class="info-item">-->
<!--        <div class="label">预计获取 Alpha 积分</div>-->
<!--        <div class="value font2">{{alphaPoints}} 积分</div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
  export default {
    name: "returned",
    props:["returnedAmount","alphaAmount","alphaPoints","selectedList"],
    data() {
      return {
      }
    },
    watch: {
    },
  }
</script>

<style lang="scss" type="text/scss" scoped>
.alpha-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 85px;
  border: 0.5px solid #ECECEC;
  border-radius: 12px;
  margin-top: 8px;

  .info-item {
    width: 50%;
    text-align: center;

    .label {
      color: #929292;
      font-size: 12px;
    }

    .value {
      color: #000;
      font-size: 20px;
      margin-top: 4px;
    }
  }
}
</style>